import { combineReducers } from 'redux';
import * as appReducers from './reducers/appReducers';
import * as userReducers from './reducers/userReducers';
import * as validationReducers from './reducers/validationReducers';
import * as httpReducers from './reducers/httpReducers';
import * as facebookReducers from './reducers/facebookReducers';
import * as authReducers from './reducers/authReducers';

const reducers = Object.assign({},
	appReducers,
	userReducers,
	validationReducers,
	httpReducers,
	facebookReducers,
	authReducers
);

/**
 * Root reducer
 * @description
 * Combines every reducer and returns a full state tree whenever
 * any reducer is called by an action. The rootReducer creates properties
 * on the state tree whose key names match the reducer names on the object passed
 * into combineReducers (or an alias if provided). This is the standard out-of-the-box
 * Redux combineReducers implementation
 */
const rootReducer = combineReducers(reducers);

export default rootReducer;

/**
 * Root UI selectors
 */
export const getRecoverableErrorType = (state, requestKey, networkStatus) => {
	const errorState = state.HTTP_request[requestKey] && state.HTTP_request[requestKey].isError ?
		state.HTTP_request[requestKey].isError : undefined;
	return httpReducers.getRecoverableErrorType(errorState, requestKey, networkStatus);
}; 


// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/index.js